<template>
  <div class=" mt-5 ">
    <v-layout row wrap>
      <v-flex>
        <section>
          <div>
            <div class="text-center ">
              <div class="fs-24 font_weight_600 black_one">
                Informasi mengenai usaha Anda
              </div>

              <div class="black_three mt-1">
                Lengkapi seluruh informasi usaha yang akan Anda daftarkan dibawah ini
              </div>
            </div>


            <div class="mt-5">
              <v-row justify="center">
                <v-col cols="7">
                  <v-card class="box-shadow">
                    <v-card-text class="pa-6">
                      <ValidationObserver 
                        ref="form">
                        <v-form>
                          <div class="fs-14 mb-1 black_two">
                            Nama Perusahaan
                            <span class="red--text">*</span>
                          </div>
                          <ValidationProvider 
                            name="Nama Perusahaan" 
                            rules="required" 
                            v-slot="{ errors }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="no_box mb-3"
                              outlined
                              hide-details
                              dense
                              :color="set_color"
                              style="border-radius: 4px;"
                              placeholder="Masukkan nama usaha anda"

                              vv-uppercase

                              v-model="form.company_name"
                              :error-messages="errors"
                              required>
                            </v-text-field>
                          </ValidationProvider>


                          <div class="fs-14 mb-1 black_two">
                            Nama Outlet
                            <span class="red--text">*</span>
                          </div>
                          <ValidationProvider 
                            name="Nama Outlet" 
                            rules="required" 
                            v-slot="{ errors }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="no_box"
                              outlined
                              hide-details
                              dense
                              :color="set_color"
                              style="border-radius: 4px;"
                              placeholder="Masukan nama outlet atau unit usaha anda"

                              vv-uppercase

                              v-model="form.outlet_name"
                              :error-messages="errors"
                              required>
                            </v-text-field>
                          </ValidationProvider>

                          <v-row>
                            <v-col cols="6">
                              <div class="fs-14 mb-1 black_two">
                                Provinsi
                                <span class="red--text">*</span>
                              </div>
                              <ValidationProvider 
                                name="Provinsi" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-autocomplete
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  hide-details
                                  dense
                                  :items="province"
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  v-on:change="changeProvince()"
                                  item-value="id"
                                  item-text="name"
                                  placeholder="Pilih provinsi"

                                  vv-uppercase

                                  v-model="form.province_id"
                                  :error-messages="errors"
                                  required>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="6">
                              <div class="fs-14 mb-1 black_two">
                                Kota / Kabupaten
                                <span class="red--text">*</span>
                              </div>
                              <ValidationProvider 
                                name="Kota / Kabupaten" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-autocomplete
                                  v-on:keyup.enter="save"
                                  v-on:change="changeCity()"
                                  item-value="id"
                                  item-text="name"
                                  class="no_box"
                                  outlined
                                  hide-details
                                  dense
                                  :items="city"
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  placeholder="Pilih Kota / Kabupaten"

                                  vv-uppercase

                                  v-model="form.city_id"
                                  :error-messages="errors"
                                  required>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="6">
                              <div class="fs-14 mb-1 black_two">
                                Kecamatan
                                <span class="red--text">*</span>
                              </div>
                              <ValidationProvider 
                                name="Kecamatan" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-autocomplete
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  hide-details
                                  dense
                                  :items="subdistrict"
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  v-on:change="changeSub()"
                                  item-value="id"
                                  item-text="name"
                                  placeholder="Pilih Kecamatan"

                                  vv-uppercase

                                  v-model="form.subdistrict_id"
                                  :error-messages="errors"
                                  required>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="6">
                              <div class="fs-14 mb-1 black_two">
                                Kelurahan
                                <span class="red--text">*</span>
                              </div>
                              <ValidationProvider 
                                name="Kelurahan" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-autocomplete
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  hide-details
                                  dense
                                  :items="village"
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  v-on:change="changeVal()"
                                  item-value="id"
                                  item-text="name"
                                  placeholder="Pilih Kelurahan"

                                  vv-uppercase

                                  v-model="form.village_id"
                                  :error-messages="errors"
                                  required>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <div class="fs-14 mb-1 black_two">
                            Alamat Lengkap
                            <span class="red--text">*</span>
                          </div>
                          <ValidationProvider 
                            name="Alamat Lengkap" 
                            rules="required" 
                            v-slot="{ errors }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="no_box mb-3"
                              outlined
                              hide-details
                              dense
                              :color="set_color"
                              style="border-radius: 4px;"
                              placeholder="Masukkan alamat"

                              vv-uppercase

                              v-model="form.address"
                              :error-messages="errors"
                              required>
                            </v-text-field>
                          </ValidationProvider>

                          <v-row>
                            <v-col
                              cols="12"
                              class="py-0">
                              <label>
                                AutoComplete
                                <gmap-autocomplete
                                  placeholder="ketik alamat"
                                  class="mb-3"
                                  @place_changed="setPlace">
                                </gmap-autocomplete>
                              </label>
                              <!-- <div
                                class="d-flex align-center mb-3">
                                <v-btn
                                  v-for="(item, index) in menu"
                                  :key="index"

                                  @click="selected.menu = item; initMap();"

                                  :color="selected.menu === item ? set_color : ''"
                                  :class="selected.menu === item ? 'white--text' : ''"
                                  :style="selected.menu === item ? 'font-weight: 600;' : ''"

                                  small
                                  rounded
                                  elevation="0"
                                  class="text-capitalize mr-4">
                                  {{ item }}
                                </v-btn>
                              </div> -->

                              <div v-if="selected.menu === 'Koordinat'">
                                <gmap-map
                                  :center="center"
                                  :zoom="12"
                                  :options="{
                                    zoomControl: true,
                                    mapTypeControl: false,
                                    scaleControl: false,
                                    streetViewControl: false,
                                    rotateControl: false,
                                    fullscreenControl: true,
                                    disableDefaultUi: false
                                  }"
                                  :clickable="true"
                                  @click="updatePlace"
                                  style="width: 100%; height: 400px;">

                                  <gmap-marker
                                    :position="center"
                                    :draggable="true"
                                    @drag="updatePlace"
                                    @click="center = center">
                                  </gmap-marker>
                                </gmap-map>
                              </div>

                              <!-- <div v-if="selected.menu === 'Polygon'">
                                <v-card
                                  flat
                                  min-height="500px"
                                  color="transparent"
                                  style="border-radius: 10px;">
                                  <div 
                                    id="map" 
                                    style="width: 100%; height: 500px;">
                                  </div>
                                </v-card>
                              </div> -->
                            </v-col>

                            <v-col
                              cols="12"
                              md="6"
                              class="pt-6">
                              <ValidationProvider 
                                name="Latitude" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-15 label-input">
                                  <!-- <span class="red--text">*</span> -->

                                  Latitude
                                </div>

                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  outlined
                                  dense
                                  readonly

                                  onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                                  type="number"
                                  min="0"

                                  :color="set_color"
                                  placeholder="Contoh. -6.1805"

                                  v-model="form.latitude"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col
                              cols="12"
                              md="6"
                              class="pt-6">
                              <ValidationProvider 
                                name="Longitude" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-15 label-input">
                                  <!-- <span class="red--text">*</span> -->

                                  Longitude
                                </div>

                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  outlined
                                  dense
                                  readonly

                                  onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                                  type="number"
                                  min="0"

                                  :color="set_color"
                                  placeholder="Contoh. 106.8284"


                                  v-model="form.longitude"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                        </v-form>
                      </ValidationObserver>
                      <div v-if="message.error.length > 0"
                        class="error--text">
                        <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </v-card-text>
                    <v-card-text style="background: #FAFAFA" class="px-6 py-4 text-right">
                      <!-- <v-btn
                        outlined
                        height="36"
                        :to="`/register/jenis-usaha`"
                        style="border-radius: 6px;"
                        elevation="0"
                        :disabled="form.jenis_usaha === ''"
                        class="text-capitalize">
                        Sebelumnya
                      </v-btn> -->
                      <v-btn
                        color="#240087"
                        height="36"
                        elevation="0"
                        :loading="process.form"
                        :disabled="process.form"
                        @click="save()"
                        style="border-radius: 6px;"
                        class="white--text text-capitalize ml-3">
                        Mendaftar
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          company_id: '',
          company_name: '',
          outlet_name: '',
          address: '',
          latitude: '',
          longitude: '',
          province_id: '',
          city_id: '',
          subdistrict_id: '',
          village_id: '',
          province: '',
          city: '',
          subdistrict: '',
          village: '',
          business_type: '',
        },
        province: [],
        city: [],
        subdistrict: [],
        village: [],
        menu: ['Koordinat', 'Polygon'],

        selected: {
          row: [],
          freeze: [],
          delete: [],

          menu: 'Koordinat'
        },

        map: null,

        center: {
          lat: -6.1805, 
          lng: 106.8284
        },

        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetchProv()
      this.form.company_id = this.$route.params.id
      this.form.business_type = (this.$route.query.usaha).split('-').join(' ')
    },
    methods: {
      async fetchProv() {

         let params = {
          limit: 10000000000000
        }

        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.province = res.results.data
          }
        })
      },

      changeProvince() {
        this.form.city_id = ''
        this.form.subdistrict_id = ''
        this.form.village_id = ''
        let id = ''
        this.province.map(obj => {
          if (obj.id === this.form.province_id) {
            id = obj.id
            this.form.province = obj.name
          }
        })
        this.fetchCity(id)
      },

      async fetchCity(id) {

         let params = {
          limit: 10000000000000,
          province_id: id
        }

        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.city = res.results.data
          }
        })
      },

      // async fetchCity(id) {

      //    let params = {
      //     limit: 10000000000000,
      //     province_id: id
      //   }

      //   await get(`ref/kota`, { params })
      //   .then(response => {
      //     let res = response.data
          
      //     if (res.status === 200) {
      //       this.city = res.results.data
      //     }
      //   })
      // },

      changeCity() {
        this.form.subdistrict_id = ''
        this.form.village_id = ''
        let id = ''
        this.city.map(obj => {
          if (obj.id === this.form.city_id) {
            id = obj.id
            this.form.city = obj.name
          }
        })
        this.fetchSub(id)
      },

      async fetchSub(id) {

         let params = {
          limit: 10000000000000,
          city_id: id
        }

        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.subdistrict = res.results.data
          }
        })
      },

      changeSub() {
        this.form.village_id = ''
        let id = ''
        this.subdistrict.map(obj => {
          if (obj.id === this.form.subdistrict_id) {
            id = obj.id
            this.form.subdistrict = obj.name
          }
        })
        this.fetchVil(id)
      },

      async fetchVil(id) {

         let params = {
          limit: 10000000000000,
          subdistrict_id: id
        }

        await get(`ref/kelurahan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.village = res.results.data
          }
        })
      },

      changeVal() {
        this.village.map(obj => {
          if (obj.id === this.form.village_id) {
            this.form.village = obj.name
          }
        })
      },


      setPlace(place) {
        this.place = place
        this.center = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        
        }
        this.initMap()
        this.form.latitude = this.place.geometry.location.lat()
        this.form.longitude = this.place.geometry.location.lng()
      },

      updatePlace (location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      // INIT MAP
      initMap () {
        let self = this

        this.$gmapApiPromiseLazy().then(() => {
          self.map = new google.maps.Map(document.getElementById('map'), {
            center: { 
              lat: -6.1805, 
              lng: 106.8284
            },
            zoom: 18,
            noClear: true,
            mapTypeId: 'hybrid', //satellite
            navigationControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            tilt: 0
          })

          self.map.data.addListener('addfeature', self.featureAdded)

          const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_LEFT,
              drawingModes: ['polygon']
            },
            polygonOptions: {
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            }
          })

          drawingManager.setMap(self.map)

          drawingManager.addListener('polygoncomplete', (polygon) => {
            if (polygon.getPath().getLength() < 3) {
              console.log('Polygons must have 3 or more points.')

              polygon.getPath().clear()
            } else {
              // self.form.latlong_json_arr = []

              this.set_polygon_complete = true

              self.addFeature('Polygon', polygon.getPath())

              polygon.setMap(null)
            }
          })

          // #JIKA SINGLE POLYGON
          // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

          // ======================== SPLIT ======================== \\

          // #JIKA MULTI POLYGON
          if (this.form.latlong_json_arr.length > 0) {
            this.form.latlong_json_arr.forEach(obj => {
              self.addFeature('Polygon', obj.latlng)
            })
          }
        })
      },

      featureAdded (e) {
        switch (e.feature.getGeometry().getType()) {
          case 'Polygon':
            addFeature('Polygon', e.feature.getGeometry().getAt(0).getArray())

            break
        }

        self.map.data.remove(e.feature)
      },

      addFeature (type, path) {
        let self = this

        let index_latlng = ''

        switch (type) {
          case 'Polygon':
            let polygon = new google.maps.Polygon({
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            })

            polygon.setPath(path)

            polygon.addListener('click', (e) => {
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.getPath().addListener('insert_at', (e) => {
              // console.log(e)
            })

            polygon.getPath().addListener('set_at', (e, obj) => {
              // self.form.latlong_json_arr[e].lat = obj.lat()
              // self.form.latlong_json_arr[e].lng = obj.lng()

              let polypath = polygon.getPath()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []
              
              for (var i = 0; i < polypath.length; i++) {
                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.getPath().addListener('remove_at', (e) => {
              // console.log(e)
            })

            polygon.addListener('dragstart', (e) => {
              // #JIKA SINGLE POLYGON
              // Konten ketika single polygon

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              let polypath = polygon.getPath()


              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === polypath.getAt(0).lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.addListener('dragend', (e) => {
              let polypath = polygon.getPath()
              let bounds = new google.maps.LatLngBounds()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   bounds.extend(polypath.getAt(i))

              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // let center = bounds.getCenter()
              // stringlocation = JSON.stringify(self.form.latlong_json_arr)
              // stringcenter = JSON.stringify(center)
              // console.log(stringcenter + stringlocation)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []

              for (var i = 0; i < polypath.length; i++) {
                bounds.extend(polypath.getAt(i))

                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.addListener('rightclick', (e) => {
              // #JIKA SINGLE POLYGON
              // if (e.vertex == undefined) return

              // if (polygon.getPath().getLength() === 3) {
              //   polygon.setMap(null)
                
              //   self.form.latlong_json_arr = []
              // } else {
              //   console.log(index_latlng)
              //   polygon.getPath().removeAt(e.vertex)
              //   self.form.latlong_json_arr.splice(e.vertex, 1)
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })

              if (e.vertex == undefined) return

              if (polygon.getPath().getLength() === 3) {
                polygon.setMap(null)
                
                // self.form.latlong_json_arr = []

                self.form.latlong_json_arr.splice(index_latlng, 1)
              } else {
                polygon.getPath().removeAt(e.vertex)
                self.form.latlong_json_arr[index_latlng].latlng.splice(e.vertex, 1)
              }
            })

            let data_polygon = polygon.getPath()

            let before_insert = []

            for (let i = 0; i < data_polygon.getLength(); i++) {
              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr.push({
              //   lat: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[0]),
              //   lng: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[1])
              // })

              // const lats = self.form.latlong_json_arr.map(o => o.lat)
              // self.form.latlong_json_arr = self.form.latlong_json_arr.filter(({lat}, index) => !lats.includes(lat, index + 1))

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              before_insert.push({
                lat: parseFloat(data_polygon.getAt(i).lat()),
                lng: parseFloat(data_polygon.getAt(i).lng())
              })

              const lats = before_insert.map(o => o.lat)
              before_insert = before_insert.filter(({lat}, index) => !lats.includes(lat, index + 1))
            }

            if (before_insert.length > 2 && self.set_polygon_complete) {
              self.form.latlong_json_arr.push({
                index: self.form.latlong_json_arr.length,
                lat: before_insert[0].lat,
                lng: before_insert[0].lng,
                latlng: before_insert
              })

              self.set_polygon_complete = false
            }

            console.log(self.form.latlong_json_arr)

            polygon.setMap(self.map)

            break
        }
      },

      addLatlng () {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.push({
        //   lat: null,
        //   lng: null
        // })

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr.push({
          index: this.form.latlong_json_arr.length,
          latlng: [
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            }
          ]
        })
      },

      removeLatlng (index) {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.splice(index, 1)

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr[index].latlng.splice(index_sub, 1)

        if (this.form.latlong_json_arr[index].latlng.length < 3) {
          this.form.latlong_json_arr.splice(index, 1)
        }

        this.initLatlng()
      },

      initLatlng () {
        let self = this

        if (this.form.latlong_json_arr.length > 2) {
          if (this.form.latlong_json_arr[2].lat !== '' && this.form.latlong_json_arr[2].lat !== null && this.form.latlong_json_arr[2].lng !== '' && this.form.latlong_json_arr[2].lng !== null) {
            this.$gmapApiPromiseLazy().then(() => {
              self.map = new google.maps.Map(document.getElementById('map'), {
                center: { 
                  lat: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lat : -7.7126396311,
                  lng: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lng : 110.5909243135
                },
                zoom: 18,
                noClear: true,
                mapTypeId: 'hybrid', //satellite
                navigationControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                tilt: 0
              })
    
              self.map.data.addListener('addfeature', self.featureAdded)
    
              const drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: this.form.latlong_json_arr.length < 1 ? google.maps.drawing.OverlayType.POLYGON : null,
                drawingControl: true,
                drawingControlOptions: {
                  position: google.maps.ControlPosition.TOP_LEFT,
                  drawingModes: ['polygon']
                },
                polygonOptions: {
                  fillColor: '#FF0000',
                  fillOpacity: 0.35,
                  strokeColor: '#FF0000',
                  strokeWeight: 2,
                  strokeOpacity: 1,
                  draggable: true,
                  editable: true,
                  clickable: true,
                  zIndex: 1
                }
              })
    
              drawingManager.setMap(self.map)
    
              drawingManager.addListener('polygoncomplete', (polygon) => {
                if (polygon.getPath().getLength() < 3) {
                  console.log('Polygons must have 3 or more points.')
                  polygon.getPath().clear()
                } else {
                  self.addFeature('Polygon', polygon.getPath())
                  polygon.setMap(null)
                }
              })
    
              // #JIKA SINGLE POLYGON
              // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              if (this.form.latlong_json_arr.length > 0) {
                this.form.latlong_json_arr.forEach(obj => {
                  self.addFeature('Polygon', obj.latlng)
                })
              }
            })
          }
        } else {
          this.initMap()
        }
      },

      async save () {
        this.message.error = ''

        const isValid = this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          await post('pos/auth/register_outlet', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              // console.log(res.results.data.mobile_key)

              // window.location = `${process.env.BASE_URL}dashboard`
                // this.$router.push({ path: `/verification-email/coba` })
              this.$router.push({ path: `/berhasil-terverifikasi` })
              

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>


<style>
 .pac-target-input {
  width: 100% !important;
  padding: 8px !important;
  border: 1px solid #d1d1d1 !important;
 }
</style>